import React from 'react';

import styled from 'styled-components';

const AddOnContainer = styled.div`
    display: table;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;

    .nw-field-addon-content {
        display: table-cell;
        min-width: 0;
        width: 100%;
        vertical-align: top;

        > * {
            min-width: 0;
            width: 100%;
        }

        .ant-select,
        .ant-input-number {
            width: 100%;
        }

        .ant-input,
        .ant-input-number,
        .ant-select-selector {
            border-top-left-radius: 0 !important;
            border-bottom-left-radius: 0 !important;
        }

        textarea.ant-input {
            margin-bottom: 0 !important;
        }
    }
`;

const AddOnBefore = styled.div`
    box-sizing: border-box;
    display: table-cell;
    min-width: 4.75rem;
    min-height: 28px;
    padding: 0 10px;
    border: ${(props) => (props.$plain ? 'none' : `1px solid ${props.theme.DarkerBorderColor}`)};
    border-right-width: 0;
    border-radius: 2px 0 0 2px;
    background-color: ${(props) => (props.$plain ? 'transparent' : props.theme.SelectedBackgroundColor)};
    color: ${(props) => props.theme.TextColorMuted};
    font-size: 0.8rem;
    text-align: center;
    text-transform: uppercase;
    vertical-align: middle;
    white-space: nowrap;
`;

const NwFieldAddOnBefore = ({ addOnBefore, children, plain }) => {
    if (!addOnBefore) {
        return children;
    }

    return (
        <AddOnContainer $plain={plain}>
            <AddOnBefore $plain={plain}>
                {typeof addOnBefore === 'string' ? addOnBefore.toUpperCase() : addOnBefore}
            </AddOnBefore>
            <div className="nw-field-addon-content">{children}</div>
        </AddOnContainer>
    );
};

export default NwFieldAddOnBefore;
